import { render } from "./ReviewTab.vue?vue&type=template&id=04fc198c&scoped=true&ts=true"
import script from "./ReviewTab.vue?vue&type=script&lang=ts"
export * from "./ReviewTab.vue?vue&type=script&lang=ts"

import "./ReviewTab.vue?vue&type=style&index=0&id=04fc198c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fc198c"]])

export default __exports__